




























import { Component, Mixins, Prop } from "vue-property-decorator";
import { ICurrency } from "@/models/constants";
import { IBrand } from "@/models/brands";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import { IState } from "@/store";
import RequestPromises from "@/mixins/requestPromises";

@Component({
  computed: {
    ...mapState({
      currencies(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.CURRENCIES,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class ChangeCurrencyModal extends Mixins(RequestPromises) {
  // Props

  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ required: true })
  public currencyCode!: ICurrency["code"];

  // Data

  public currencies!: ICurrency[];
  public dataScope = "";
  public isLoading = true;
  public newCurrencyCode = "";

  // Life-cycle Methods

  public async created() {
    try {
      this.isLoading = true;
      this.dataScope = `$brand_${this.brandId}`;
      this.newCurrencyCode = this.currencyCode;
      await this.getBrandCurrencies();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.$emit("close");
    } finally {
      this.isLoading = false;
    }
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.CURRENCIES,
      scope: this.dataScope,
      vm: this
    });
  }

  // Computed

  public get currencyCodes() {
    return this.$_.map(this.currencies, ({ code }) => code);
  }

  public get formIsInvalid() {
    return !this.currencyCodes.includes(this.newCurrencyCode);
  }

  // Methods

  public getBrandCurrencies() {
    return this.$store.dispatch(`data/${DataModules.CURRENCIES}/list`, {
      ignoreStored: true,
      scope: this.dataScope,
      vm: this,
      params: {
        brand_id: this.brandId,
        limit: 0
      }
    });
  }

  public async validateBeforeSubmit() {
    if (this.formIsInvalid) return;
    this.$emit("success", this.newCurrencyCode);
    this.$emit("close");
  }
}
